import script from "./ResultsView.vue?vue&type=script&setup=true&lang=ts"
export * from "./ResultsView.vue?vue&type=script&setup=true&lang=ts"

import "./ResultsView.vue?vue&type=style&index=0&id=960b1ca0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-960b1ca0"]])

export default __exports__